import { cn } from "@paribus/shared-ui";
import type { ReactElement } from "react";

interface FirmSettingsViewProps {
  isLoading: boolean;
  firmName: string;
  isSaving: boolean;
  canSave: boolean;
  onFirmNameChange: (firmName: string) => void;
  onSave: () => void;
}

export const FirmSettingsView = ({
  isLoading,
  firmName,
  isSaving,
  canSave,
  onFirmNameChange,
  onSave,
}: FirmSettingsViewProps): ReactElement => {
  if (isLoading) {
    return <div className="flex h-64 items-center justify-center">Loading...</div>;
  }

  return (
    <div className="mx-auto max-w-4xl px-4 py-8">
      <div className="rounded-lg bg-card shadow">
        <div className="border-b border-border px-6 py-4">
          <h2 className="text-xl font-semibold text-foreground">Firm Settings</h2>
        </div>

        <div className="space-y-6 p-6">
          <div>
            <label
              htmlFor="firm-settings-name"
              className="mb-2 block text-sm font-medium text-muted-foreground"
            >
              Firm Name
            </label>
            <input
              id="firm-settings-name"
              type="text"
              value={firmName}
              onChange={(e) => onFirmNameChange(e.target.value)}
              className="w-full rounded-md border border-input px-3 py-2 focus-visible:shadow-focus"
              placeholder="Enter firm name"
            />
          </div>
        </div>

        <div className="flex justify-end border-t border-border px-6 py-4">
          <button
            onClick={onSave}
            disabled={isSaving || !canSave}
            className={cn(
              "rounded-md bg-primary px-4 py-2 text-primary-foreground hover:bg-primary-hover focus-visible:shadow-focus",
              (isSaving || !canSave) && "cursor-not-allowed opacity-50"
            )}
          >
            {isSaving ? "Saving..." : "Save Changes"}
          </button>
        </div>
      </div>
    </div>
  );
};
